<script setup>
import {RouterView} from 'vue-router'
import HeaderNavBar from './components/HeaderNavBar.vue'
</script>
<template>
  <HeaderNavBar v-if="$route.meta.header !== 0" />
  <main role="main">
    <RouterView/>
  </main>
  <img class="mb-4" src="@/assets/nithra_loader-big.gif" id="loadingImage" alt="" width="72"
       height="72" style="
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 9999;
">
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  margin-top: 80px;
}

.dropdown:hover .dropdown-menu {
  display: block;
  margin-top: 0; /* remove the gap so it doesn't close */
}

div.navbar-brand {
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
